import {Dialog, Fade, useMediaQuery, useTheme} from "@mui/material";
import {TransitionProps} from "@mui/material/transitions";
import {
    BaseSyntheticEvent,
    ReactElement,
    Ref,
    forwardRef,
    useState,
} from "react";
import {
    DialogContext,
    DialogDataContainer,
} from "../contexts/DialogueContext";
import {createRandomId} from "../utils/random";

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: Ref<unknown>
) {
    return <Fade ref={ref} {...props} />;
});

// updated
export default function DialogProvider(props: {
    children: JSX.Element | JSX.Element[];
}) {
    const [dialogs, setDialogs] = useState<DialogDataContainer[]>([]);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    let openDialog = (
        element: JSX.Element,
        onClose?: (result?: any) => void,
        backDropClose: boolean = true
    ) => {
        const key = createRandomId(10);
        const dialog = {
            element,
            show: true,
            key: key,
            onClose,
            backDropClose,
        };
        const updatedDialogs = [...dialogs, dialog];
        setDialogs(updatedDialogs);
    };

    const closeDialog = (result: any | BaseSyntheticEvent) => {
        // the reason we create new array is that
        // calling reverse will make it in-place
        const updatedDialogs = [...dialogs].reverse();
        for (let dialog of updatedDialogs) {
            if (dialog.show) {
                dialog.show = false;
                if (dialog.onClose) {
                    dialog.onClose(
                        result?.nativeEvent instanceof Event ? null : result
                    );
                }
                break;
            }
        }

        setDialogs(updatedDialogs);
    };

    const modalValue = {
        dialogs,
        openDialog,
        closeDialog,
    };

    return (
        <DialogContext.Provider value={modalValue}>
            {props.children}

            {dialogs.map((elem) => {
                return (
                    <Dialog
                        maxWidth={"lg"}
                        sx={{
                            overflow: "visible !important",
                            animation: elem.show
                                ? "backDropAnimation 0.3s forwards"
                                : "backDropAnimationClose 0.3s",
                        }}
                        fullScreen={fullScreen}
                        onClose={elem.backDropClose ? closeDialog : () => {
                        }}
                        TransitionComponent={Transition}
                        open={elem.show}
                        key={elem.element.key ?? elem.key}
                    >
                        {elem.element}
                    </Dialog>
                );
            })}
        </DialogContext.Provider>
    );
}
